import { useState } from 'react';
import {
  default as DropdownComponentWithSearch,
  DropdownComponentWithSearchOption,
} from 'fc/components/DropdownComponentWithSearch';
import Modal from '../Modal/modal';
import { Button } from 'fc/components/Button';

interface DocumentReviewModalProps {
  modalConfig: {
    title: string;
    onClose: () => void;
    isOpen: boolean;
    handleSubmit: (data: unknown) => void;
  };
  reasonDropdownConfig: {
    options: DropdownComponentWithSearchOption[];
    label: string;
  };
}

export const EscalationRejectionModal: React.FC<DocumentReviewModalProps> = ({
  modalConfig: { title, onClose, isOpen, handleSubmit },
  reasonDropdownConfig: { options, label },
}) => {
  const [selectedOption, setSelectedOption] =
    useState<DropdownComponentWithSearchOption>();
  const [description, setDescription] = useState<string>('');

  const handleClose = () => {
      setSelectedOption(undefined)
    setDescription('');
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onOpenChange={handleClose}
      title={title}
      titleClassName="font-p22Mackinac font-100"
    >
      <div className="mb-4">
        <label
          className="block text-gray-700 text-sm font-normal mb-2"
          htmlFor="rejectReason"
        >
          {label}
        </label>
        <div className="relative">
          <DropdownComponentWithSearch
            placeHolder="Choose an option"
            items={options}
            selectedItem={selectedOption}
            setSelectedItem={setSelectedOption}
          />
        </div>
      </div>
      <div className="mb-4">
        <label
          className="block text-gray-700 text-sm font-normal mb-2"
          htmlFor="rejectDescription"
        >
          Description*
        </label>
        <textarea
          className="shadow appearance-none border rounded w-full h-[100px] py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline placeholder:text-sm placeholder:font-thin"
          id="rejectDescription"
          placeholder="Explain here..."
          maxLength={250}
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <div className="text-right text-xs text-gray-600">
          {description?.length}/250
        </div>
      </div>
      <div className="flex justify-center">
      <Button
    className={`${
         "bg-iris-100 text-white"
    }`}
    disabled={selectedOption && description ? false : true}
    onClick={() => {
      handleSubmit({
        reason: selectedOption?.label || "",
        code: selectedOption?.value || "",
        description,
      });
      setDescription('');
      setSelectedOption(undefined)
    }}
  >
    Submit
  </Button>
      </div>
    </Modal>
  );
};
